// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function getTitleSlugFromContentTitle(contentTitle: string) {
  return contentTitle
    .replace(/([^a-z^A-Z^0-9^ ])/g, '')
    .replace(/ +(?= )/g, '') // replace multiple spaces, with a single space
    .replace(/ /g, '-')
    .toLowerCase();
}
